var map = {
	"./A8.wav": "6be0",
	"./As8.wav": "3cf8",
	"./B8.wav": "1663",
	"./C8.wav": "5894",
	"./Cs8.wav": "8ba3",
	"./D8.wav": "1589",
	"./Ds8.wav": "4b17",
	"./E8.wav": "b56f",
	"./F8.wav": "83d0",
	"./Fs8.wav": "08f4",
	"./G8.wav": "aaee",
	"./Gs8.wav": "d1a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dfe1";